export default __webpack_public_path__ + "static/media/BrixSansExtralight.1ff87bd8.woff2";